import React from "react"
import lekkerhome from "../assets/images/lekker-home.png"
import bulksupplements from "../assets/images/bulksupplements.png"
import italic from "../assets/images/italic.png"
import afloral from "../assets/images/afloral.png"

function TrustedByBanner() {
  return (
    <div className={`row four-columns trusted-by-section`}>
      <h2 className="text-center">Trusted by growing brands</h2>

      <div className="col-md-3 text-center trusted-logo">
        <div className="logo-wrapper">
          <img
            src={lekkerhome}
            alt="Lekker Home"
            className="img-fluid"
            width="300"
          />
        </div>
      </div>
      <div className="col-md-3 text-center trusted-logo">
        <div className="logo-wrapper">
          <img
            src={bulksupplements}
            alt="Bulk Supplements"
            className="img-fluid"
            width="300"
          />
        </div>
      </div>
      <div className="col-md-3 text-center trusted-logo">
        <div className="logo-wrapper">
          <img src={italic} alt="Italic" className="img-fluid" width="300" />
        </div>
      </div>
      <div className="col-md-3 text-center trusted-logo">
        <div className="logo-wrapper">
          <img src={afloral} alt="Afloral" className="img-fluid" width="300" />
        </div>
      </div>
    </div>
  )
}

export default TrustedByBanner
